// utm_campaign values of the guest hotel emails (HA1, HA2, G1, G2) sent by travel_notification_service.
const HOTEL_EMAIL_UTM_CAMPAIGNS: ReadonlySet<string> = new Set(['reminder', 'rate_drop', 'f_booking', 'f_booking_rate_drop']);

// The UTMs that identify a hotel-email click.
const HOTEL_EMAIL_UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'] as const;

type UtmTriple = Readonly<{ utm_source?: string | null; utm_medium?: string | null; utm_campaign?: string | null }>;

/** True for the UTMs of one of the guest hotel emails. */
export const isHotelEmailUtm = ({ utm_source, utm_medium, utm_campaign }: UtmTriple): boolean =>
  utm_source === 'j2g' && utm_medium === 'email' && HOTEL_EMAIL_UTM_CAMPAIGNS.has(utm_campaign ?? '');

/** `utm`, unless it is a hotel-email set: then `fallback`, so a link built from it can't trip RoomBlockEmailRedirect. */
export const withoutHotelEmailUtm = <U extends UtmTriple, F extends UtmTriple>(utm: U, fallback: F): U | F => (isHotelEmailUtm(utm) ? fallback : utm);

/** True when the URL is a click from one of the guest hotel emails. */
export const isHotelEmailClick = (search: string): boolean => {
  const params = new URLSearchParams(search);
  return isHotelEmailUtm({ utm_source: params.get('utm_source'), utm_medium: params.get('utm_medium'), utm_campaign: params.get('utm_campaign') });
};

/** The query string without the hotel-email UTMs ('' or '?…'); every other param is kept. */
export const stripHotelEmailUtm = (search: string): string => {
  const params = new URLSearchParams(search);
  HOTEL_EMAIL_UTM_KEYS.forEach(key => params.delete(key));
  const rest = params.toString();
  return rest ? `?${rest}` : '';
};
